var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var AboutSourcesMap = function(el) {
  this.$el = $(el);
  this.$map = this.$el.find('.about-sources-map-map');
  this.modal_content = {};

  // Bind events
  this.$el
    .on('click', '.about-sources-map-map li a', this.loadContent.bind(this));

  this.$el.on('change', 'select', function(event) {
    var val = $(event.currentTarget).val();
    this.$el.find('.about-sources-map-nav a[href="#'+val+'"]').click();
  }.bind(this));

  // Trigger first to open
  this.$el.find('.about-sources-map-nav>ul>li:first-child>a').trigger('click');

};

AboutSourcesMap.prototype = {

  loadSourceModal: function(content, products) {
  	if(content !== false) {
  		this.modal_content.content = content;
  	}
  	if(products !== false) {
  		this.modal_content.products = products;
  	}
    // Response contains source content HTML
    if(this.modal_content.content && this.modal_content.products) {
	    $( document ).trigger( 'OpenModal', [ this.modal_content.content+this.modal_content.products ] );
	    this.modal_content = {};
    }
  },

  loadContent: function(event) {
    event.preventDefault();

    var target = $(event.currentTarget);
    var id = target.attr('data-post-id');

    // Open modal with loading message
    $( document ).trigger( 'OpenModal', [ 'loading' ] );

    this.loadSourceContent(id);
    this.loadSourceProducts(id);

  },

  loadSourceContent: function(id) {
    var self = this;
    $.ajax({
      url: SiteVars['json_url']+'/module/source-content/'+id,
      type: 'GET',
      success: function(response) {
        self.loadSourceModal(response.html, false);
      }.bind(this)
    });

  },

  loadSourceProducts: function(id) {
    var self = this;
    $.ajax({
      url: SiteVars['json_url']+'/module/source-products/'+id,
      type: 'GET',
      success: function(response) {
        self.loadSourceModal(false, response.html);
      }.bind(this)
    });

  }

};

module.exports = AboutSourcesMap;
